// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const benefits = {
  benefits_section: {
    contentful_name: 'Benefits Section (DEFAULT DO NOT CHANGE)',
    title_info_bar: {
      healthPlan: '太好了,您已选择了一项医疗保健计划!',
      noHealthPlan: '您已选择不参加健康保险计划。',
      hsaContribution: '您的健康储蓄账户(HSA)供款已锁定。',
    },
    button_text: {
      allDone: '是的,让我们审核',
      undoPlan: '改变主意了',
      breakdown: '计划明细',
      learnMore: '了解更多',
      noDetails: 'PDF不可用',
      plansFrom: '计划起价',
      viewPlans: '选择',
      choosePlan: '选择计划',
      goToReview: '继续审核',
      selectPlan: '选择此计划',
      updatePlan: '更新选择',
      addCoverage: '添加更多保障',
      notEligible: '不符合资格',
      planDetails: '完整计划详情',
      learnMorePdf: '完整计划详情',
      selectedPlan: '已选择计划',
      unselectPlan: '取消选择',
      hideBreakdown: '隐藏明细',
      notInterested: '不感兴趣',
      backToBenefits: '返回所有福利',
    },
    benefit_page_heading: '{x}保险',
    benefits_heading: '您的补充福利',
    benefits_description: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '这些计划在您的健康保险计划之外提供额外的保障、福利或优惠。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    no_benefits_available: '根据您的员工组别,您不符合任何额外福利的资格。请继续前往审核页面。',
    covered_benefits_title: '承保福利',
    card_additions: {
      onePlan: '1 个计划起价',
      manyPlans: '{x} 个计划起价',
      fullDetails: '……(查看完整详情)',
      hraIncluded: '您看到此信息是因为您已注册符合 HRA 资格的健康计划。',
      hsaIncluded: '您看到此信息是因为您已注册符合 HSA 资格的健康计划。',
    },
    footer_text: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '您已选择 ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '**{x}**',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ' 个',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '补充计划',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: '(包括自动注册的计划)。全部完成了吗?',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    no_plans_footer_text: '如果您准备好了,让我们开始复习。',
    auto_enrolled_info: {
      tagText: '雇主支付',
      tipText: '您的雇主提供此福利,无需额外费用。',
      tipTitle: '自动注册',
      modalTitle: '您的雇主提供自动注册计划',
      moreCoverage: '您还可以选择购买以下保障,该保障提供超出您自动注册计划所涵盖范围的福利。',
    },
    reasons_why_heading: {
      icon: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/warning-black.svg',
      title: '为什么要考虑{x}?',
      title_fsa: '为什么要考虑{x}?',
    },
    reasons_why: {
      sports: 'If your children play any sports.',
      tobacco: 'Tobacco use increases the risk of being diagnosed with a covered condition.',
      eyeExams: "Even if you don’t wear glasses, it's a good idea to get routine eye exams.",
      age40to50:
        'You said that you or your partner are over 40 years old. If you have a family history of any covered conditions, you may be at greater risk.',
      ageOver50:
        'You said that you or your partner are over 55 years old. You may benefit from this type of insurance because of higher age-related risk of being diagnosed with a covered condition.',
      childcare:
        'If you are planning on paying for qualifying childcare, this account can help you save on taxes.',
      pregnancy: 'You may receive benefits if you get bills for inpatient labor and delivery.',
      eyeGlasses: 'This coverage helps pay for glasses or contacts, if you need them.',
      childDental: 'If your child has or needs braces, this coverage may help reduce the costs.',
      moderateRisk:
        'People with {x} risk aversion often value having benefits like this that provide extra risk protection.',
      childActivity:
        'You have a kid, and we all know kids can be accident-prone, especially if they’re physically active or play sports.',
      lifeDependent:
        'Because you have dependents, you may want to consider adding life insurance to make sure your family’s financial needs are covered, even if you’re not around.',
      parentalLeave: 'This coverage can help cover lost wages for any time off work following childbirth.',
      prescriptions: 'People who take a similar amount of prescriptions tend to select these policies.',
      childrenDental: 'If your kids have or need braces, this coverage may help reduce those costs.',
      youngDependent: 'Since you have children under the age of 6.',
      dentalCleanings: 'This coverage will help you cover the cost of routine dental care.',
      extraProtection:
        'You said that you could afford to pay {x} for an unexpected medical bill, which means you could especially benefit from extra protection against lost wages from disability.',
      childrenActivity:
        'You have {x} kids, and we all know kids can be accident-prone, especially if they’re physically active or play sports.',
      hospitalAdmission:
        'You said that you or someone in your family was admitted to a hospital in the last 12 months. People with prior hospital admissions are more likely than average to experience a hospital admission in the future.',
      cashValueRetention:
        'Unlike life or long-term care insurance plans that are use-it-or-lose-it, this type of plan builds value over time. And if you change your mind, you can cancel the plan and keep its cash value.',
      groupRateAdvantage:
        'By purchasing a group policy through your employer, you may be able to get a better rate than you would on your own.',
      longTermDisability:
        'You may want to consider adding Long-Term Disability coverage, which is an affordable way to reduce your financial risk if you become disabled. That’s worth a look.',
      highDeductLowCapacity:
        'Your medical plan’s {healthDeductible} deductible exceeds what you said you can afford to pay ({capacityToPay}). This extra benefit can help you cover that gap.',
      plannedProcedureInpatient:
        "You've told us that you or a family member is planning to have an inpatient procedure in the next 12 months.",
    },
    your_plans_heading: '您的{x}计划',
    member_coverage_text: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '您正在覆盖 ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
                {
                  type: 'code',
                },
              ],
              value: '{x}',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    coverage_options: {
      all: '所有人',
      allV3: '全家',
      yourself: '您自己',
      isCovered: '是,已覆盖',
      notCovered: '未覆盖',
      yourselfV3: '您自己',
      youAndSpouse: '您和您的配偶/伴侣',
      familyMembers: '{x}名家庭成员',
      youAndSpouseV3: '您和配偶/伴侣',
      familyMembersV3: '{x}名家庭成员',
    },
    single_plan: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '有 ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '1 个计划',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ' 可供选择。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    multiple_plans: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value: '有 ',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'code',
                },
              ],
              value: '**{x}**',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: ' 个',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [
                {
                  type: 'bold',
                },
              ],
              value: '计划',
              nodeType: 'text',
            },
            {
              data: {},
              marks: [],
              value: '可供选择。',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
    learn_more_text: '了解更多关于此福利提供的内容。',
    plan_card_text: {
      benefits: {
        title: '承保福利',
        covered: '已承保',
        payouts: '承保福利赔付',
        deductible: '免赔额',
        maxBenefit: '年度最高福利',
        notCovered: '不承保',
        orthodontia: '正畸',
        seeFullDetails: '查看完整详情。',
      },
      exclusions: {
        title: '除外责任和限制',
        instructions: '有关除外责任和限制,请参阅计划明细。',
      },
      notEligible: '并非所有家庭成员都符合此计划的资格。如需继续,请取消选择不符合资格的成员。',
      notEligibleWarning: {
        yourself: '仅投保人符合资格。',
        youAndSpouse: '仅投保人和配偶符合资格。',
        youAndDependents: '仅投保人和受抚养人符合资格。',
      },
    },
    health_benefit: {
      contentful_name: '[default] Health Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/health.svg',
      card_title: '健康',
      alternate_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      card_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    dental_benefit: {
      contentful_name: '[default] Dental Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/dental.svg',
      card_title: '牙科',
      alternate_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      card_description: '牙科保险帮助承保牙科检查、洗牙、补牙、正畸等费用。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '牙科保险可以帮助支付常规牙科护理的费用,如洗牙和X光检查,以及意外服务的费用,如补牙、牙冠和牙桥。一些计划还涵盖正畸治疗,但可能有年龄限制。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '有了牙科保险,您支付的是牙科保险公司与您的牙医或正畸医生协商好的价格,而您的保险将帮助您承担其中一部分费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '您还需要支付保费,并可能需要支付免赔额,其运作方式与您的常规健康保险相同。一旦达到免赔额,保险计划就会开始支付您大部分的医疗费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '然而,牙科保险计划通常不是设定',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [
                  {
                    type: 'italic',
                  },
                ],
                value: '您',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [],
                value: '支付的自付费用上限,而是设定',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [
                  {
                    type: 'italic',
                  },
                ],
                value: '保险公司',
                nodeType: 'text',
              },
              {
                data: {},
                marks: [],
                value: '支付的年度最高限额。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319367',
      alternate_video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      video_source: 'Vimeo',
      notes: {
        note: '牙科保险计划通常设有每年的最高赔付金额上限。即使您超出此金额,您仍可享受保险公司与网络内医疗服务提供者协商的优惠价格。',
        title: '牙科保险最高赔付额',
      },
      benefit_page_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    vision_benefit: {
      contentful_name: '[default] Vision Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/vision.svg',
      card_title: '愿景',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '视力保险帮助支付眼科检查、眼镜、隐形眼镜和意外视力问题的费用。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '视力保险计划有助于支付常规眼科检查的费用——通常每年一次——需支付固定的共付额或共同保险。如果您需要眼镜或隐形眼镜,该计划也会提供帮助,但在特定年份可能只涵盖其中一种。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '某些视力保险计划可能有助于承保矫正手术(如LASIK激光手术),或为处方太阳镜等项目提供额外折扣。请查看您的保险计划详情以了解具体信息。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      video_link: 'https://vimeo.com/813319998',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      notes: {
        note: '视力保险计划通常设有每年支付的最高福利限额,但即使您超出最高福利金额,您仍可享受保险提供商协商的优惠价格。',
        title: '最高视力福利',
      },
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
    },
    accident_benefit: {
      contentful_name: '[default] Accident Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/accident.svg',
      card_title: '事故',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '意外伤害保险在您遭受承保范围内的意外伤害时提供赔付。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '即使是我们当中最健康、最注重安全的人也会时不时地遇到意外。而意外伤害也会带来意想不到的经济负担。意外保险可以帮助您或受保的家庭成员支付这些不可预见的医疗费用和自付费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '如果您遭受保单定义的承保意外伤害,意外保险将向您开具支票以帮助支付您的费用。该支票可用于任何用途:医疗账单、交通费用、日常购物——完全由您决定。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '请注意,如果您在进行危险活动时受伤,例如悬崖跳水或地下摩托车竞速,保单通常不会赔付。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319209',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      notes: {
        note: '您获得的赔付金额取决于您的伤情和治疗方式,通常针对特定承保伤害或护理设有固定金额。',
        title: '赔付说明',
      },
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    illness_benefit: {
      contentful_name: '[default] Critical Illness Benefit',
      icon_link:
        'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/critical-illness.svg',
      card_title: '重大疾病',
      alternate_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      card_description: '重疾险在您被诊断患有承保疾病时提供赔付。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '被诊断出患有疾病不仅会影响您的身体健康,还可能对您的财务健康产生重大影响。从医疗账单到工资损失,再到房租和日常食品等基本生活必需品,重大疾病保险可以帮助您应对严重疾病带来的意外费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '重大疾病保险在您或受保家庭成员遭遇某些重大疾病(如癌症、心脏病发作或中风)时向您支付现金。在大多数保单中,您可以选择终身最高赔付额,如果您被诊断患有承保范围内的疾病,保单将支付该金额的一定百分比。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319306',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      notes: {
        note: '许多保单对既往症有例外规定,并且大多数赔付都有等待期,因此请务必在投保前仔细查看详细条款。',
        title: '赔付说明',
      },
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    hospital_benefit: {
      contentful_name: '[default] Hospital Benefit',
      icon_link:
        'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/hospital-indemnity.svg',
      card_title: '住院津贴保险',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '住院补偿保险承保意外伤害,并帮助支付住院费用。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '住院补偿保险会在您因符合条件的疾病或伤害需要住院治疗时向您支付赔偿金。即使您已拥有健康保险,住院治疗仍可能让您面临高额医疗账单,例如需要支付的免赔额、共付额或共同保险费用,或者网络外医疗费用。此外,您还可能产生额外的非医疗费用,如儿童看护费和交通费。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '有了住院补偿保险,一旦您的住院符合保单要求,保险计划就会向您寄送支票。款项直接支付给您,您可以随意支配这笔钱,无论是用于支付医疗账单、为前来探望的亲友支付住宿和交通费用,还是用于帮助解决您专注康复期间出现的任何其他需求。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319577',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    life_benefit: {
      contentful_name: '[default] Life Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/life.svg',
      card_title: '生活',
      alternate_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      card_description: '人寿保险在任何受保家庭成员身故时提供赔付。',
      alternate_description:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '人寿保险是一种确保您所爱之人得到照顾的方式,即使您不在身边。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '人寿保险保单通常非常简单明了:如果您去世,您所爱的人将获得一次性的整笔赔付。只需确保在投保时指定受益人(或多个受益人),以便资金能够发放到正确的地方。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '您可以根据家庭需求选择想要购买的保额,但根据您的保单和保障级别,您可能需要提供"可保性证明"——本质上就是医生证明。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319533',
      alternate_video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      video_source: 'Vimeo',
      notes: {
        note: '人寿保险赔付金没有任何附加条件。您的家人可以使用这些资金来支付住房、教育、债务和丧葬费用等开支。',
        title: '关于赔付的说明',
      },
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    death_dismemberment_benefit: {
      contentful_name: '[default] Death & Dismemberment Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/add.svg',
      card_title: '意外身故及伤残',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description:
        '意外死亡和伤残(AD&D)保险在您因意外事故死亡或失去身体部位或功能时,将向您或您的受益人支付一笔总额赔偿金。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '意外死亡和伤残(AD&D)保险是由许多令人不安的词汇组合而成,但在可怕的情况下却能提供很大的帮助。AD&D保险在您因意外事故死亡或伤残时向您或您的受益人支付一笔总额赔付。如果您同时拥有AD&D保单和人寿保险保单,在发生致命事故时,您的受益人将从两份保单中获得全额赔付。如果您遭遇导致伤残的事故——即失去身体部位或功能,如视力、听力或语言能力——赔付金额将取决于伤害的性质。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '当您购买意外死亡和伤残保险(AD&D)保单时,您可以选择承保金额,该金额决定了您或您的受益人将获得的赔付额度。您选择的承保金额将影响您的保费,如果您从事高风险工作或经常参与高风险活动,您可能还需要支付更高的保费。请查看您的保单详情以获取更多信息。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319254',
      alternate_video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
    },
    std_benefit: {
      contentful_name: '[default] Short Term Disability Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/std.svg',
      card_title: '短期伤残保险',
      alternate_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated, and I will immediately generate the accurate translation.',
      card_description: '短期伤残保险在规定期限内,当您因疾病或受伤无法工作时,会支付您部分收入。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '短期伤残保险可以帮助您在短期内无法工作时替代部分收入——通常为三到六个月。该保单将替代您收入的一定百分比,但是,您可能需要等待一段时间后保单才会开始支付赔偿金。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '大多数短期伤残保险政策会在您因分娩而休假时提供赔付。保障金额和等待期都会影响您的保费。请查看您的计划详情,了解您可享有的具体政策。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319726',
      alternate_video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    ltd_benefit: {
      contentful_name: '[default] Long Term Disability Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/disability.svg',
      card_title: '长期伤残保险',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '长期伤残保险在您因疾病或受伤而残疾达到规定时间后无法工作时,会支付您部分收入。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '长期伤残保险可以在您较长时间无法工作时帮助替代部分收入——通常是指超过六个月的时期。该保单将替代您收入的一定百分比,但是,您可能需要等待一段时间后保单才会开始支付赔偿。这个等待期,或称"免赔期",通常从三十天到两年不等,但最常见的是九十天。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '保险金额和等待期都会影响您的保费。请查看您的计划详情以了解您可享有的具体保单。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319650',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated, and I will immediately generate the translation for you.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    retirement_benefit: {
      contentful_name: '[default] Retirement Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/retirement.svg',
      card_title: '退休',
      alternate_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      card_description: '退休储蓄计划让您在扣税前将部分工资存入并投资用于退休。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '退休储蓄对您的长期财务健康至关重要,而税收优惠退休储蓄账户是充分利用您退休金缴款的有用工具。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '税收优惠退休储蓄账户可以帮助您节省税款,相比其他投资账户更具优势。它们最常见的方式是允许您使用税前资金向账户供款,这被称为传统供款。某些账户还可能允许您进行罗斯供款,即在资金存入账户时缴税,但在退休时提取资金则无需纳税。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '请查看您的计划详情以获取更多信息。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319902',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    four_o_one_k_benefit: {
      contentful_name: '[default] 401k Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/retirement.svg',
      card_title: '401(k)退休计划',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '401(k)计划让您在扣税前将部分工资储蓄和投资用于退休。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '退休储蓄对您的长期财务健康至关重要,而税收优惠退休储蓄账户是充分利用您退休金缴款的有用工具。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '税收优惠退休储蓄账户可以帮助您节省税款,相比其他投资账户更具优势。它们最常见的方式是允许您使用税前资金向账户供款,这被称为传统供款。某些账户还可能允许您进行罗斯供款,即您在资金存入账户时缴税,但在退休时提取资金则无需纳税。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '请查看您的计划详情以获取更多信息。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319902',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated, and I will immediately generate the translation for you.',
    },
    hsa_benefit: {
      contentful_name: '[default] HSA Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/hsa.svg',
      card_title: '健康储蓄账户',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '健康储蓄账户(HSA)可帮助您在支付某些自付医疗费用时节省资金。',
      alternate_description:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      modal_description: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '虽然健康保险可以帮助您支付医疗费用,但它并不能涵盖所有费用。健康储蓄账户(HSA)是为这些费用储蓄的绝佳方式。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [
                  {
                    type: 'italic',
                  },
                ],
                value: '以下是运作方式:',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '首先,在注册符合HSA资格的健康计划后,开设一个健康储蓄账户。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value:
                          '接下来,选择一个缴款金额,该金额将从您的工资中扣除。一些雇主也会向您的HSA缴款来帮助您。您今年未使用的任何资金都归您所有,即使您换工作也是如此。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
            ],
            nodeType: 'unordered-list',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [
                  {
                    type: 'italic',
                  },
                ],
                value: '以下是您应该了解的其他事项',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value:
                          '您可以使用HSA支付符合条件的医疗费用,包括医疗共付额、视力和牙科费用、处方药等。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '您向HSA缴纳的任何资金都会降低您的税款。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '2022年,个人每年最多可缴纳',
                        nodeType: 'text',
                      },
                      {
                        data: {},
                        marks: [
                          {
                            type: 'code',
                          },
                        ],
                        value: '{x}',
                        nodeType: 'text',
                      },
                      {
                        data: {},
                        marks: [],
                        value: ',家庭每年最多可缴纳',
                        nodeType: 'text',
                      },
                      {
                        data: {},
                        marks: [
                          {
                            type: 'code',
                          },
                        ],
                        value: '{x}',
                        nodeType: 'text',
                      },
                      {
                        data: {},
                        marks: [],
                        value: '。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value:
                          '随着您的余额增长,您可以投资这笔资金。最棒的是,任何收益以及用于符合条件费用的任何提款都是免税的。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
            ],
            nodeType: 'unordered-list',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '请务必仔细查看您的计划详情以获取更多信息。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319552',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
    },
    hra_benefit: {
      contentful_name: '[default] HRA Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/hra.svg',
      card_title: '健康报销安排',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '健康报销安排(HRA)可帮助您在支付某些自付医疗费用时节省开支。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '您的健康保险计划附带健康报销安排(HRA)。HRA是由您的雇主设立并向其注资的账户,用于帮助您支付符合条件的自付医疗费用。这可能包括医疗挂号费、视力和牙科费用、处方药等。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [
                  {
                    type: 'italic',
                  },
                ],
                value: '运作方式如下:',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value:
                          '一旦您注册符合HRA资格的计划,您的雇主将为您的账户注资,您可以使用这些资金来抵消医疗费用。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value:
                          '当您接受医疗护理时,保险公司将从您的HRA中支付您医疗计划所涵盖的医疗账单,直到您用完所有分配的资金。根据您雇主设置HRA的方式,您可能需要提交收据以获得报销。但请记住,您的报销金额仅限于雇主为您的HRA注资的金额。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
            ],
            nodeType: 'unordered-list',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [
                  {
                    type: 'italic',
                  },
                ],
                value: '以下是您应该了解的其他事项',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value:
                          '如果您没有用完所有HRA资金进行报销,您可能可以在未来几年使用这些资金,具体取决于您的雇主允许您结转的金额。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value:
                          '如果您决定注册不符合HRA资格的计划或离开当前雇主,您将失去雇主为您贡献的所有HRA资金。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
            ],
            nodeType: 'unordered-list',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '请务必仔细查看您的计划详情以获取更多信息。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319594',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    fsa_benefit: {
      contentful_name: '[default] FSA Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/fsa.svg',
      card_title: '弹性支出账户',
      alternate_title: '医疗保健有限用途FSA',
      card_description: '弹性支出账户(FSA)可让您在支付某些自付医疗费用时节省资金。',
      alternate_description: '有限用途灵活支出账户(LPFSA)是一种税前账户,可用于支付符合条件的牙科和视力费用。',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '如果您的健康计划符合弹性支出账户(FSA)的资格,您可以利用此账户来帮助支付医疗费用。重要的是只存入您认为会用到的金额,因为FSA资金必须在缴款当年使用。未使用的资金将在年底退还给您的雇主。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  'FSA允许您每年留出最多3,050美元的免税供款来支付医疗费用。如果您的配偶也在同一计划中,您可以供款两倍的金额。FSA供款必须在年底前使用。未使用的余额将归还给您的雇主,因此重要的是只供款您认为会使用的金额。雇主可以提供最多2.5个月的宽限期来使用FSA资金,他们还可以允许您将最多610美元结转到下一年使用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/499286816',
      alternate_video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    medical_fsa_benefit: {
      contentful_name: '[default] Medical FSA Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/fsa_m.svg',
      card_title: '医疗保健FSA',
      alternate_title: '医疗保健有限用途FSA',
      card_description: '医疗保健弹性支出账户(FSA)是一种税前账户,可用于支付符合条件的医疗、牙科和视力费用。',
      alternate_description:
        '医疗有限用途弹性支出账户(LPFSA)是一种税前账户,可用于支付符合条件的牙科和视力费用。',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '医疗保健弹性支出账户(Health Care FSA)是一种税前福利账户,您可以使用它来支付健康保险计划未涵盖的合格医疗、牙科和视力保健费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '当您注册时,您将决定全年的缴款金额。然后,您的雇主会在整个计划年度内从您的工资中等额扣除您的缴款金额。但好消息是:您无需等待账户中的资金积累!您的全年选定金额将在计划年度的第一天全部可用,因此您可以立即开始使用您的账户支付符合条件的费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '请查看您的计划详情以获取更多信息。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319704',
      alternate_video_link: 'https://vimeo.com/813319737',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    dependent_fsa_benefit: {
      contentful_name: '[default] Dependent FSA Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/fsa_dc.svg',
      card_title: '受抚养人护理FSA',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description:
        '受抚养人护理FSA(DCFSA)是一个税前账户,可用于支付符合条件的受抚养人护理服务费用,如学前教育、夏令营日间营地、课前或课后项目以及儿童或成人日间护理。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '受抚养人护理FSA(DCFSA)是一种税前账户,您可以用它来支付您工作期间的受抚养人护理服务费用。对于此账户,"受抚养人"包括13岁以下的儿童以及无法自理的成年受抚养人。成年受抚养人必须与您同住,并在您的纳税申报表中作为受抚养人申报,其费用才符合资格。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '当您注册账户时,您需要决定全年要缴纳多少金额,但不得超过年度限额。然后,您的雇主会在整个计划年度内从您的工资中等额扣除您的缴纳金额。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您可以通过两种方式使用受抚养人护理FSA中的资金:',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '直接从账户向您的受抚养人护理服务提供者付款。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '先自付受抚养人护理费用,然后从账户中报销。',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
            ],
            nodeType: 'ordered-list',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '*注意:您也可能有资格申请受抚养人护理税收抵免,但已通过DCFSA报销的费用不能同时计入税收抵免的合格费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '请查看您的计划详情以获取更多信息。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319430',
      alternate_video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    adoption_fsa_benefit: {
      contentful_name: '[default] Adoption FSA Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/fsa_aa.svg',
      card_title: '领养援助FSA',
      alternate_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      card_description: '领养援助FSA为您在合法领养符合条件的儿童过程中产生的合理且必要的费用提供报销。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '领养援助FSA为您提供报销,用于补偿您在合法领养符合条件的儿童过程中产生的合理且必要的费用,包括领养费、法庭费用、律师费和相关差旅费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '请务必仔细查看您的计划详情以获取更多信息。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      alternate_video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      video_source:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    telemedicine_benefit: {
      contentful_name: '[default] Telemedicine Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/telemed.svg',
      card_title: '远程医疗',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '远程医疗让您能够通过电话与医生进行问诊,以诊断常见疾病和病症。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319935',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    pet_benefit: {
      contentful_name: '[default] Pet Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/pet.svg',
      card_title: '宠物保险',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '宠物保险可以帮助您支付兽医费用。',
      alternate_description:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '宠物保险可以通过承担部分兽医诊疗和治疗费用,帮助您更经济实惠地为毛茸茸的家庭成员提供医疗保健。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '通常,宠物保险仅适用于狗和猫。某些计划可能涵盖更多异国宠物,如鸟类、蜥蜴或马匹,但您可能需要支付更高的保费。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '具体涵盖哪些服务以及计划费用多少,通常取决于以下因素:',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '您拥有的宠物类型',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '它们的具体品种',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '它们的年龄',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '它们的性别',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
              {
                data: {},
                content: [
                  {
                    data: {},
                    content: [
                      {
                        data: {},
                        marks: [],
                        value: '您的居住地',
                        nodeType: 'text',
                      },
                    ],
                    nodeType: 'paragraph',
                  },
                ],
                nodeType: 'list-item',
              },
            ],
            nodeType: 'unordered-list',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '当您的宠物需要护理时,您需要预先支付医疗费用。然后,您的宠物保险保单将报销总费用的一定百分比或计划确定的固定金额。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '与人类健康保险一样,在保险生效之前,您需要满足免赔额要求。一旦达到免赔额,您就可以提交费用以获得报销,最高可达保单的年度限额。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '请查看您的计划详情以了解具体信息。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      alternate_video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      video_source:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      benefit_page_title: '宠物保险',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    commuter_benefit: {
      contentful_name: '[default] Commuter Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/commuter.svg',
      card_title: '通勤福利',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '通勤福利让您有机会使用税前资金支付通勤费用。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319795',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      custom_module_benefit:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
    },
    partner_benefit: {
      contentful_name: '[default] Medicare',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/medicare.svg',
      card_title: '医疗保险',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description:
        '考虑退休、即将年满65岁,或为亲人寻找相关信息?现在就开始了解Medicare注册,并获得免费的个性化Medicare建议。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '联邦医疗保险(Medicare)可能很复杂,但您不必独自面对。无论您是护理人员、即将年满65岁,还是正在规划退休,非营利组织全国老龄委员会都会为您提供帮助。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      insurance_info: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '以下是您应该了解的内容',
                marks: [
                  {
                    type: 'italic',
                  },
                ],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'ordered-list',
            content: [
              {
                nodeType: 'list-item',
                content: [
                  {
                    nodeType: 'paragraph',
                    content: [
                      {
                        nodeType: 'text',
                        value: '医疗保险(Medicare)覆盖范围有多种选择。',
                        marks: [],
                        data: {},
                      },
                    ],
                    data: {},
                  },
                ],
                data: {},
              },
              {
                nodeType: 'list-item',
                content: [
                  {
                    nodeType: 'paragraph',
                    content: [
                      {
                        nodeType: 'text',
                        value: '医疗保险的注册通常仅在每年的特定时间开放。',
                        marks: [],
                        data: {},
                      },
                    ],
                    data: {},
                  },
                ],
                data: {},
              },
              {
                nodeType: 'list-item',
                content: [
                  {
                    nodeType: 'paragraph',
                    content: [
                      {
                        nodeType: 'text',
                        value:
                          '虽然有些人会自动获得医疗保险,但如果年满65岁(或接近65岁)且未领取社会保障金,则可能需要自行注册。',
                        marks: [],
                        data: {},
                      },
                    ],
                    data: {},
                  },
                ],
                data: {},
              },
              {
                nodeType: 'list-item',
                content: [
                  {
                    nodeType: 'paragraph',
                    content: [
                      {
                        nodeType: 'text',
                        value: '首次符合资格时未注册医疗保险B部分(Part B)可能会导致罚款。',
                        marks: [],
                        data: {},
                      },
                    ],
                    data: {},
                  },
                ],
                data: {},
              },
              {
                nodeType: 'list-item',
                content: [
                  {
                    nodeType: 'paragraph',
                    content: [
                      {
                        nodeType: 'text',
                        value: '可能有医疗保险费用补助。',
                        marks: [],
                        data: {},
                      },
                    ],
                    data: {},
                  },
                ],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '无论您处于医疗保险旅程的哪个阶段,请务必获取所需信息,以便为您和您的亲人做出最佳选择。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '全国老龄委员会健康老龄规划工具\n医疗保险',
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '需要帮助为您或您的亲人找到合适的计划?立即开始:',
                marks: [],
                data: {},
              },
              {
                nodeType: 'hyperlink',
                data: {
                  uri: 'https://www.ncoa.org/age-well-planner/landing/medicare-enrollment-help-awp',
                },
                content: [
                  {
                    nodeType: 'text',
                    value: 'https://www.ncoa.org/age-well-planner/landing/medicare-enrollment-help-awp',
                    marks: [],
                    data: {},
                  },
                ],
              },
            ],
            data: {},
          },
        ],
      },
      video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    legal_services_benefit: {
      contentful_name: '[default] Legal Services',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/legal_services.svg',
      card_title: '法律服务',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '法律计划是雇主提供的一项补充福利,旨在为员工提供经验丰富的律师网络服务。',
      alternate_description:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '法律计划提供律师网络的访问权限。您可以访问任何这些网络律师,费用将由您的法律计划全额承担。就像您的其他福利一样,您通过每月便捷的工资扣除方式支付此项服务费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '在许多情况下,您可能需要合格法律专业人士的建议或协助。例如,如果您正在买卖房屋并需要合同、契约或购买协议。或者,如果您正在组建家庭并想要创建遗嘱或需要帮助准备遗产规划文件。法律计划甚至可以为您提供律师协助处理交通罚单或身份盗窃保护。身份盗窃是指个人使用他人姓名或个人身份信息进行欺诈或其他犯罪行为。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '这些计划通常涵盖最常见的法律问题,但每个计划可能有所不同,因此务必查看计划详情以确认您的事项是否在承保范围内。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '法律计划是一个很好的选择,因为它以远低于自行聘请律师的成本,提供了获得优质法律服务的经济实惠途径。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319859',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    employee_assistant_program_benefit: {
      contentful_name: '[default] EAP',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/EAP.svg',
      card_title: '员工援助计划',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '员工援助计划(EAP)可以帮助解决与心理和情绪健康相关的各种问题。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '寻求帮助并不容易,但员工援助计划(EAP)可以让获得帮助变得更简单一些。员工援助计划是一个集中的服务平台,在那里有人随时准备倾听您面临的任何问题,然后将您与专业帮助联系起来——比如财务顾问、法律专家或心理健康咨询师——或提供额外的资源,为您提供自助工具。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '一般来说,EAP可以帮助解决法律问题、药物滥用问题、财务咨询等方面的事务。您讨论的所有内容都将完全保密,所涵盖的服务不会向您收取任何费用,但如果您被转介给医疗保健专业人员,可能会产生一些费用。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      video_link: 'https://vimeo.com/813319756',
      alternate_video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    wellness_benefit: {
      contentful_name: '[default] Wellness Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/wellness.svg',
      card_title: '健康福利',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
      card_description: '健康福利计划旨在帮助改善员工的整体健康和福祉,重点在于减少疾病和提高生活质量。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '健康福利可以包括各种促进员工身体、情感和心理健康改善的服务。这些类型的福利可以包括健康筛查、戒烟计划、健身竞赛或压力管理计划。有些甚至包括健身房会员费、饮食计划或健身追踪器的报销,并且可能为达到健身目标提供奖励。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '健康计划可以带来多种积极益处。这些计划可以帮助您采取主动措施来改善身心健康,能够降低压力,提高日常工作效率,从长远来看还可以帮助您节省开支,因为更好的健康状况从长远来看可以转化为更低的医疗费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '健康计划中包含的福利类型取决于具体计划,因此请务必查看您的计划详情。了解哪些福利可能专门适用于您是个好主意,这样您就可以从今天开始改善您的健康和福祉。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319967',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
    },
    financial_wellness_benefit: {
      contentful_name: '[default] Financial Wellness Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/financial_wellness.svg',
      card_title: '财务健康福利',
      alternate_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      card_description: '财务健康福利包括一系列服务,旨在帮助员工改善其财务状况。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '财务健康是一个影响许多人日常生活的重大问题。如果您曾经遇到过财务困难,就会知道这有多么令人压力重重。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '财务健康这个术语指的是您财务状况的整体情况,以及它如何不仅影响您的压力水平,还影响您的身心健康。当您为财务问题感到焦虑时,很难专注于其他任何事情。当您拥有良好的财务健康状况时,您可以完全掌控日常财务,有足够的储蓄来应对意外开支,并且在退休和储蓄目标方面步入正轨。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value:
                  '财务健康福利包括一系列服务。咨询和辅导服务可以为您提供一对一的建议,帮助您改善财务健康状况,财务专家可以帮助您全面审视自己的财务状况,并与您一起制定改善计划。这些专家可以帮助您制定预算、坚持执行预算并评估您的成效。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '由于财务健康福利可以涵盖多种服务,最好查看您的计划详情以了解提供哪些服务。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      video_link: 'https://vimeo.com/813319830',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    combined_life_and_add_benefit: {
      contentful_name: '[default] Life/AD&D (combined)',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/life.svg',
      card_title: '人寿/意外伤害及伤残保险',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description:
        '人寿保险和意外死亡及伤残保险是可以帮助保护您所爱之人免受因死亡或严重伤害而导致的经济困难的福利。',
      alternate_description:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      modal_description: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                nodeType: 'text',
                value: '您提供的内容为空。请提供需要翻译的英文内容,我将为您翻译成简体中文。',
                marks: [],
                data: {},
              },
            ],
            data: {},
          },
        ],
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '我们希望能够一直陪伴在亲人身边并为他们提供保障,但人寿保险和意外死亡及伤残(AD&D)保险为您提供了为最坏情况做准备的方式,在您去世或严重受伤时为您的受抚养人提供资金以支付相关费用。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '人寿保险保单通常非常简单明了:如果您去世,您的亲人将获得一次性总付款项。只需确保在注册时指定受益人(或多位受益人),以便资金流向正确的地方。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '意外死亡及伤残(AD&D)保险听起来是一堆可怕的词汇组合,但在可怕的情况下可以提供很大帮助。AD&D保险在您因意外事故死亡或伤残时向您或您的受益人支付一笔总付款项。如果您同时拥有AD&D保单和人寿保险保单,在发生致命事故时,您的受益人将从两份保单中获得全额赔付。如果您遭遇导致伤残的事故——即失去身体部位或功能,如视力、听力或语言能力——赔付金额将取决于伤害的性质。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '虽然人寿保险和AD&D保险通常一起提供,但保费可能会根据您选择的承保金额而有所不同。请查看您的计划详情以获取更多信息。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319533',
      alternate_video_link:
        'I notice that the content to translate is empty. There is no text provided between the `<text></text>` tags for me to translate from English (United States) to Chinese (Simplified, China).\n\nPlease provide the content you would like translated.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
    },
    four_o_three_benefit: {
      contentful_name: '[default] 403(b) Benefit',
      icon_link: 'https://picwellapppublicdata.s3.amazonaws.com/contentful/insuranceicons/retirement.svg',
      card_title: '403(b)',
      alternate_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      card_description: '403(b)计划允许您在扣税前将部分工资储蓄和投资用于退休。',
      alternate_description:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      modal_description: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '退休储蓄对您的长期财务健康至关重要,而税收优惠退休储蓄账户是充分利用您退休金缴款的有用工具。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      insurance_info: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value:
                  '税收优惠退休储蓄账户可以帮助您节省税款,相比其他投资账户更具优势。它们最常见的方式是允许您使用税前资金向账户供款,这被称为传统供款。某些账户还可能允许您进行罗斯供款,即在资金存入账户时缴税,但在退休时提取资金则无需纳税。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
          {
            data: {},
            content: [
              {
                data: {},
                marks: [],
                value: '请查看您的计划详情以获取更多信息。',
                nodeType: 'text',
              },
            ],
            nodeType: 'paragraph',
          },
        ],
        nodeType: 'document',
      },
      video_link: 'https://vimeo.com/813319902',
      alternate_video_link:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      video_source: 'Vimeo',
      benefit_page_title:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation immediately.',
      custom_module_benefit:
        'I notice that the content to translate is empty (the `<text></text>` tags contain no text). \n\nPlease provide the English content you would like me to translate into Simplified Chinese, and I will complete the translation for you.',
    },
  },
};
